/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L7_Hero_H1_EmInputs */

const es_l7_hero_h1_em = /** @type {(inputs: L7_Hero_H1_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rendir.`)
};

const gl_l7_hero_h1_em = /** @type {(inputs: L7_Hero_H1_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`render.`)
};

const en_l7_hero_h1_em = /** @type {(inputs: L7_Hero_H1_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`earning.`)
};

/**
* | output |
* | --- |
* | "earning." |
*
* @param {L7_Hero_H1_EmInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l7_hero_h1_em = /** @type {((inputs?: L7_Hero_H1_EmInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L7_Hero_H1_EmInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l7_hero_h1_em(inputs)
	if (locale === "en") return en_l7_hero_h1_em(inputs)
	return es_l7_hero_h1_em(inputs)
});